import { Component, OnInit, Inject  } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class PartnersComponent implements OnInit {

  Filter: {[k: string]: any} = {};
  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());

  showAddNewPartnerPopUp = false;
  showEditPartnerPopUp = false;
  masterData:any;
  partnersMasterData:any;
  PartnerSheetTypes:any[];
  Periods:any[];
  PartnerSheetEntryTypes:any[];
  DecimalPrecisions:any[];
  Currencies:any[];
  EmailNotificationTypes:any[];
  Frequencies:any[];
  PrefferedStockFormats:any[];

  // MatPaginator Output
  pageEvent: PageEvent;
  resultsLength = 0;
  pageSize = 10;
  pageIndex = 0;

  //new partner members
  newPartnerCountry:any;
  newPartnerBank:any;

  newPartner:any;
  partner:any;
  
  currentPartner:any;

  searchTerm:string;
  countryID:number;

  PartnerSheet:any;
  loadingExport:boolean;

  displayedColumnsPartners: string[] = ['Name', 'VAT', 'UPN', 'COCRegNumber', 'ContactName', 'Registered', 'Actions'];
  Partners:any[];

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router) {

    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');
   }

  ngOnInit(): void {
    this.masterData = this.parent.masterData;
    this.initializeAddPartnerForm();
    this.GetPartnersFiltered(this.searchTerm, this.countryID, false);
    this.InitializeFilter();
    this.GetPartnersMasterData();
  }
  
  initializeAddPartnerForm(){
    this.newPartner = new FormGroup({

      VAT:new FormControl(''),
      UPN:new FormControl(''),
      Name:new FormControl('', [Validators.required]),
      COCRegNumber:new FormControl(''),
  
      TaxPayer:new FormControl(''),
  
      Country:new FormControl(''),
      StateProvince:new FormControl('', [Validators.required]),
      City:new FormControl('', [Validators.required]),
      AddressLine:new FormControl('', [Validators.required]),
      ZipCode:new FormControl(''),
  
      Bank:new FormControl(''),
      BankAccount:new FormControl(''),
      BankAccountCurrency:new FormControl(''),
  
      Email: new FormControl('', [Validators.email]),
      ContactName:new FormControl(''),
      Phone:new FormControl(''),
    });
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

  initializePartnerFormFromObject(partner:any){

    this.currentPartner = new FormGroup({

      VAT:new FormControl(partner.VAT),
      UPN:new FormControl(partner.UPN),
      Name:new FormControl(partner.Name, [Validators.required]),
      COCRegNumber:new FormControl(partner.COCRegNumber),
  
      TaxPayer:new FormControl(partner.TaxPayer),
  
      Country:new FormControl(partner.BillingAddress.Country),
      StateProvince:new FormControl(partner.BillingAddress.StateProvince, [Validators.required]),
      City:new FormControl(partner.BillingAddress.City, [Validators.required]),
      AddressLine:new FormControl(partner.BillingAddress.AddressLine, [Validators.required]),
      ZipCode:new FormControl(partner.BillingAddress.ZipCode),
  
      Bank:new FormControl(partner.Bank),
      BankAccount:new FormControl(partner.Bank.BankAccount),
      BankAccountCurrency:new FormControl(partner.Bank.BankAccountCurrency),
  
      Email: new FormControl(partner.ContactInfo.Email, [Validators.email]),
      ContactName:new FormControl(partner.ContactInfo.Name),
      Phone:new FormControl(partner.ContactInfo.Phone),
    });
   
    this.showEditPartnerPopUp = true;
    this.partner = partner;
  }

  InitializeFilter(){

    this.Filter = {};
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;
    this.Filter.Partner = {};
    this.Filter.DocumentStatus = {};
    this.Filter.Period = {};
    this.Filter.Period = null;
    this.Filter.Country = {};
    this.Filter.Country = null;
    this.Filter.Currency = {};
    this.Filter.Currency = null;
    this.Filter.DecimalPrecision = {};
    this.Filter.DecimalPrecision = null;

    this.Filter.Type = {};
    this.Filter.Type = null;

    this.Filter.BankAccount = {};
    this.Filter.BankAccount = null;
    this.Filter.BankAccountCurrency = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 25;
    this.Filter.Pager.TotalCount = 0;
  }

  AddNewPartner(){

    var request = {
      Partner:{
        VAT:this.newPartner.controls['VAT'].value,
        UPN:this.newPartner.controls['UPN'].value,
        Name:this.newPartner.controls['Name'].value,
        COCRegNumber:this.newPartner.controls['COCRegNumber'].value,

        TaxPayer:false,

        BillingAddress:{
          Country:this.newPartner.controls['Country'].value,
          StateProvince:this.newPartner.controls['StateProvince'].value,
          City:this.newPartner.controls['City'].value,
          AddressLine:this.newPartner.controls['AddressLine'].value,
          ZipCode:this.newPartner.controls['ZipCode'].value,
        },
        Bank:this.newPartnerBank,
        ContactInfo:{
          Email:this.newPartner.controls['Email'].value,
          Name:this.newPartner.controls['ContactName'].value,
          Phone:this.newPartner.controls['Phone'].value,
        },
        Company:this.parent.Company
      },
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    if(request.Partner.Bank != null){
      request.Partner.Bank.BankAccount = this.newPartner.controls['BankAccount'].value;
      request.Partner.Bank.BankAccountCurrency = this.newPartner.controls['BankAccountCurrency'].value;
    }

    if(this.newPartner.controls['TaxPayer'].touched != false && this.newPartner.controls['TaxPayer'].value != ''){
      request.Partner.TaxPayer = this.newPartner.controls['TaxPayer'].value;
    }
    else{
      request.Partner.TaxPayer = false;
    }
    
    if(this.newPartner.valid){

      this.parent.loading = true;

      this.service.AddNewPartner(request).subscribe(response => {

        if(response["Status"] != 1){

        }
        else if(response["Status"] == 1){
          this.initializeAddPartnerForm();
          this.showAddNewPartnerPopUp = false;
          this.GetPartnersFiltered(this.searchTerm, this.countryID, false);
          if(response["DuplicateDetected"]){
            this.parent.openSnackBar(this.parent.translate.instant("Management.DuplicatePartnerDetected") + ": " + (response["Partner"]?.Name || ""), "OK", "alert-danger-snackbar");
          } else {
            this.parent.openSnackBar(this.parent.translate.instant("Management.AddNewPartner"), "OK", "light-info-snackbar");
          }
        }

        this.parent.loading = false;
      });
       };

     if(!this.newPartner.valid){
      this.newPartner.controls['Name'].touched = true;
      this.newPartner.controls['Country'].touched = true;
      this.newPartner.controls['StateProvince'].touched = true;
      this.newPartner.controls['City'].touched = true;
      this.newPartner.controls['AddressLine'].touched = true;
      this.newPartner.controls['ZipCode'].touched = true;
      }

    }

    getPageEvent(event?:PageEvent){
      this.pageEvent = event;
      this.pageIndex = this.pageEvent.pageIndex;
      this.GetPartnersFiltered(this.searchTerm, this.countryID, false);
    }

    GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
      var request = {
        SearchTerm:searchTerm,
        CountryID:CountryID,
        PageIndex:1,
        PageSize:this.pageSize,
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Company:this.parent.Company,
        SearchEUVIES:true
      };

      if(this.pageEvent != null && !resetPaging){
        if(this.pageEvent.pageIndex != null){
          request.PageIndex = this.pageEvent.pageIndex + 1;
        }
      }

      if(resetPaging == true && this.pageEvent != null){
        this.pageEvent.pageIndex = 0;
      }

      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         if(response["NewPartnerDetected"] == true){

          var p = JSON.parse(JSON.stringify(response["PendingPartner"]));

          if(p != null){
            this.newPartner = new FormGroup({

              VAT:new FormControl(p.VAT),
              UPN:new FormControl(''),
              Name:new FormControl(p.Name, [Validators.required]),
              COCRegNumber:new FormControl(''),
          
              TaxPayer:new FormControl(p.EUVATVerified),
          
              Country:new FormControl(p.BillingAddress.Country),
              StateProvince:new FormControl(''),
              City:new FormControl(''),
              AddressLine:new FormControl(p.BillingAddress.AddressLine),
              ZipCode:new FormControl(''),
          
              Bank:new FormControl(''),
              BankAccount:new FormControl(''),
              BankAccountCurrency:new FormControl(''),
          
              Email: new FormControl('', [Validators.email]),
              ContactName:new FormControl(''),
              Phone:new FormControl(''),
            });
          }

          this.showAddNewPartnerPopUp = true;
        }
        else{
          this.Partners = response["Partners"];
          this.resultsLength = response["Count"];
        }
        }
     
        this.parent.loading = false;
      });
    }

    GetPartnerEUData(partner:any, addnew:boolean){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        VAT:partner.value.VAT,
        CountryCode:partner.value.Country.ShortName
      };
  
      this.parent.loading = true;
  
      this.service.GetPartnerEUData(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1 && response["EUVATVerified"] == true){
  
          if(addnew){
  
            this.newPartner = new FormGroup({
  
              VAT:new FormControl(response["VAT"]),
              UPN:new FormControl(''),
              Name:new FormControl(response["Name"], [Validators.required]),
              COCRegNumber:new FormControl(''),
          
              TaxPayer:new FormControl(response["EUVATVerified"]),
          
              Country:new FormControl(response["Country"]),
              StateProvince:new FormControl(''),
              City:new FormControl(''),
              AddressLine:new FormControl(response["Address"], [Validators.required]),
              ZipCode:new FormControl(''),
          
              Bank:new FormControl(''),
              BankAccount:new FormControl(''),
              BankAccountCurrency:new FormControl(''),
          
              Email: new FormControl('', [Validators.email]),
              ContactName:new FormControl(''),
              Phone:new FormControl(''),
            });
          }
          else{
  
            this.currentPartner = new FormGroup({
  
              VAT:new FormControl(response["VAT"]),
              UPN:new FormControl(this.partner.UPN),
              Name:new FormControl(response["Name"], [Validators.required]),
              COCRegNumber:new FormControl(this.partner.COCRegNumber),
          
              TaxPayer:new FormControl(response["EUVATVerified"]),
          
              Country:new FormControl(response["Country"]),
              StateProvince:new FormControl(this.partner.BillingAddress.StateProvince, [Validators.required]),
              City:new FormControl(this.partner.BillingAddress.City, [Validators.required]),
              AddressLine:new FormControl(response["Address"], [Validators.required]),
              ZipCode:new FormControl(this.partner.BillingAddress.ZipCode),
          
              Bank:new FormControl(this.partner.Bank),
              BankAccount:new FormControl(this.partner.Bank.BankAccount),
              BankAccountCurrency:new FormControl(''),
          
              Email: new FormControl(this.partner.ContactInfo.Email, [Validators.email]),
              ContactName:new FormControl(this.partner.ContactInfo.Name),
              Phone:new FormControl(this.partner.ContactInfo.Phone),
            });
  
            this.partner.EUVATVerified = response["EUVATVerified"];
          }
        }
     
        this.parent.loading = false;
      });
    }

    UpdatePartner(){
      var request = {
        Partner:{
          ID:String,
          VAT:this.currentPartner.controls['VAT'].value,
          UPN:this.currentPartner.controls['UPN'].value,
          Name:this.currentPartner.controls['Name'].value,
          COCRegNumber:this.currentPartner.controls['COCRegNumber'].value,
  
          TaxPayer:this.currentPartner.controls['TaxPayer'].value,
  
          BillingAddress:{
            ID:Number,
            Country:this.currentPartner.controls['Country'].value,
            StateProvince:this.currentPartner.controls['StateProvince'].value,
            City:this.currentPartner.controls['City'].value,
            AddressLine:this.currentPartner.controls['AddressLine'].value,
            ZipCode:this.currentPartner.controls['ZipCode'].value,
          },
          Bank:this.currentPartner.controls['Bank'].value,
          ContactInfo:{
            ID:Number,
            Email:this.currentPartner.controls['Email'].value,
            Name:this.currentPartner.controls['ContactName'].value,
            Phone:this.currentPartner.controls['Phone'].value,
          },
          Company:this.parent.Company
        },
        User:this.parent.User,
        Language:this.parent.getLanguage()
      };

      request.Partner.Bank.BankAccount = this.currentPartner.controls['BankAccount'].value;
      request.Partner.Bank.BankAccountCurrency = this.currentPartner.controls['BankAccountCurrency'].value;

      request.Partner.ID = this.partner.ID;
      request.Partner.BillingAddress.ID = this.partner.BillingAddress.ID;
      request.Partner.ContactInfo.ID = this.partner.ContactInfo.ID;

      this.parent.loading = true;

      this.service.UpdatePartner(request).subscribe(response => {
     
        if(response["Status"] != 1){
        
        }
        else if(response["Status"] == 1){
         this.showEditPartnerPopUp = false;
         this.GetPartnersFiltered(this.searchTerm, this.countryID, false);
         this.parent.openSnackBar("Partner Updated", "OK", "light-info-snackbar");
        }
     
        this.parent.loading = false;
      });
    }

    DeletePartner(partner:any){

      var request = {
        PartnerID:partner.ID,
        AddressID:partner.BillingAddress.ID,
        ContactID:partner.ContactInfo.ID,
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Company:this.parent.Company
      };

      this.parent.loading = true;

      this.service.DeletePartner(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 20000);
        }
        else if(response["Status"] == 1){
         this.GetPartnersFiltered(this.searchTerm, this.countryID, false);
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
     
        this.parent.loading = false;
      });
    }

    GeneratePartnerSheet(){

      var request = {
        PartnerID:this.currentPartner.ID,
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.Filter,
        SheetType:this.SheetType
      };
    
      if(request.Filter.FromDate != null){
        request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
        this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      }
  
      if(request.Filter.ToDate != null){
        request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
        this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      }

      this.parent.loading = true;

      this.service.GeneratePartnerSheet(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.FromDate = new FormControl(moment(this.Filter.FromDate));
          this.ToDate = new FormControl(moment(this.Filter.ToDate));

          this.PartnerSheet = response["PartnerSheet"];
        }
     
        this.ShowPrePartnerSheet = false;
        this.ShowPartnerSheet = true;
        this.parent.loading = false;
      });
    }

    GetPartnersMasterData(){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
      };

      this.parent.loading = true;

      this.service.GetPartnersMasterData(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.PartnerSheetTypes = response["PartnerSheetTypes"];
          this.SheetType = this.PartnerSheetTypes[2];
          this.Periods = response["Periods"];
          this.PartnerSheetEntryTypes = response["PartnerSheetEntryTypes"];
          this.DecimalPrecisions = response["DecimalPrecisions"];
          this.Filter.DecimalPrecision = this.DecimalPrecisions[0];
          this.Currencies = response["Currencies"];
          this.Filter.Currency = this.Currencies[0];
          this.EmailNotificationTypes = response["EmailNotificationTypes"];
          this.Frequencies = response["Frequencies"];
          this.PrefferedStockFormats = response["PrefferedStockFormats"];

          if(this.currentPartner != null){
            if(this.currentPartner.BillingAddress != null){
              if(this.currentPartner.BillingAddress.Country != null){
                if(this.currentPartner.BillingAddress.Country.Currency != null){
                  this.Filter.Currency = this.currentPartner.BillingAddress.Country.Currency;
                }
              }
            }
          }
        }
     
        this.parent.loading = false;
      });
    }

    public ShowPrePartnerSheet:boolean = false;
    public ShowPartnerSheet:boolean = false;
    SheetType:any;

    OpenPrePartnerSheetPopUp(element:any){
      this.currentPartner = element;
      this.ShowPrePartnerSheet = true;
    }

    AddActiveFilter(filterName:string, filterType:string){
  
      if(filterType == "Period"){
        this.Filter.FromDate = null;
        this.Filter.ToDate = null;
  
        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
    }

    ClearPeriod(){
      this.Filter.Period = null;
  
    }
  
    DisablePeriod(){
      this.Filter.Period = null;
    }

    ExportPartnerSheet(print:boolean = false){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        PartnerSheet:this.PartnerSheet
      };

      this.loadingExport = true;

      this.service.ExportPartnerSheet(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          
          if(print){
            var Document = response["Document"];
            this.printPage(Document.Name , Document.PDFStream, Document.ID);
          }
          else{
            var Document = response["Document"];
            this.download(Document.Name, Document.PDFStream);
          }
        }

        this.loadingExport = false;
      });
    }

    printPage(name:string, html:string, ID:string) {
      var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
      'resizable,screenX=50,screenY=50,width=850,height=1050';
    
    var htmlPop = '<embed width=100% height=100%'
      + ' type="application/pdf"'
      + ' src="data:application/pdf;base64,'
      + escape(html)
      + '"></embed>';
    
    var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
    newWindow.document.write(htmlPop);
    };

    download(filename, text) {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
    
      element.style.display = 'none';
      document.body.appendChild(element);
    
      element.click();
    
      document.body.removeChild(element);
    }

    ShowCombinePartnerSecurityCheckErrorQuestion:boolean;
    ShowCombinePartnerSecurityCheckErrorQuestionMessage:string;

    CombinePartners(partners:any[], targetPartner:any, SecurityCheck:boolean){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Partners:partners,
        TargetPartner:targetPartner,
        SecurityCheck:SecurityCheck
      };

      this.parent.loading = true;

      this.service.GlobalCombinePartners(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
          this.GetPartnersFiltered(this.searchTerm, this.countryID, false);
        }
        
        this.parent.loading = false;
      });
    }

    ShowCombinePartners:boolean;
    SelectedPartners:any[];
    TargetPartner:any;

    OpenCombinePartners(){

      this.TargetPartner = null;
      this.SelectedPartners = [];

      this.Partners.forEach(element => {
        if(element.IsSelected){
          this.SelectedPartners.push(element);
        }
      });

      this.ShowCombinePartners = true;
    }

    GeneratePartnerNotificationEmailSubjectAndBody(PartnerID:string){
      this.parent.GeneratePartnerNotificationEmailSubjectAndBody(PartnerID, this.EmailNotificationTypes[0]);
    }

    ShowAutomatedTasksConnections:boolean;
    AutomatedTasksConnections:any[];

    GetAutomatedTasksConnections(PartnerID:string){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        PartnerID:PartnerID
      };

      this.parent.loading = true;

      this.service.GetAutomatedTasksConnections(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.ShowAutomatedTasksConnections = true;
          this.AutomatedTasksConnections = response["AutomatedTasksConnections"];
        }
     
        this.parent.loading = false;
      });
    }

    UpdateAutomatedTaskConnections(){
      this.AutomatedTasksConnections.forEach(element => {
        this.AddUpdateAutomatedTaskConnection(element);
      });
    }

    AddUpdateAutomatedTaskConnection(task:any){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        AutomatedTasksConnection:task,
      };

      this.parent.loading = true;

      this.service.AddUpdateAutomatedTaskConnection(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.ShowAutomatedTasksConnections = false;
        }
     
        this.parent.loading = false;
      });
    }

    AddOrDeletePartnerAgentFromTaskConnection(AgentID:number, AutomatedTaskID:number, IsSelected:boolean){
      if(IsSelected == true){
        this.DeletePartnerAgentsAutomationTaskConnection(AgentID, AutomatedTaskID);
      }
      else{
        this.AddPartnerAgentsAutomationTaskConnection(AgentID, AutomatedTaskID);
      }
    }

    AddPartnerAgentsAutomationTaskConnection(AgentID:number, AutomatedTaskID:number){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        AgentID:AgentID,
        AutomatedTaskID:AutomatedTaskID
      };

      this.parent.loading = true;

      this.service.AddPartnerAgentsAutomationTaskConnection(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          
        }
     
        this.parent.loading = false;
      });
    }

    DeletePartnerAgentsAutomationTaskConnection(AgentID:number, AutomatedTaskID:number){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        AgentID:AgentID,
        AutomatedTaskID:AutomatedTaskID
      };

      this.parent.loading = true;

      this.service.DeletePartnerAgentsAutomationTaskConnection(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          
        }
     
        this.parent.loading = false;
      });
    }

    ShowStockFormatContainer:boolean;

    OpenStockFormatContainer(p:any){
      this.currentPartner = p;
      this.GetPartnerPrefferedStockFormat(p.ID);
    }

    AddUpdatePartnerPrefferedStockFormat(PartnerID:string, FormatID:number){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        FormatID:FormatID,
        PartnerID:PartnerID
      };

      this.parent.loading = true;

      this.service.AddUpdatePartnerPrefferedStockFormat(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          
        }
     
        this.parent.loading = false;
      });
    }

    GetPartnerPrefferedStockFormat(PartnerID:string){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        PartnerID:PartnerID
      };

      this.parent.loading = true;

      this.service.GetPartnerPrefferedStockFormat(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.currentPartner.PrefferedStockFormat = response["PrefferedStockFormat"];
          this.ShowStockFormatContainer = true;
        }
     
        this.parent.loading = false;
      });
    }
}
